package com.evoapps.evoshift.domain.repository

import com.evoapps.evoshift.domain.model.ShiftChecklist

/** SH-127: when the tablet shows a shift's checklists. */
enum class KioskChecklistMoment {
    /** After a clock-in: the opening checklists not finished. */
    OPEN,

    /** Before (or right after) a clock-out: every checklist of the shift not finished. */
    CLOSE
}

/**
 * SH-127: a shift's checklists on the clock-in tablet. The tablet is not a person and cannot write
 * the person's checklist, so every call goes through the kioskChecklist function with the person's
 * PIN (the same checks and lockout as clocking). Refusals fail with KioskException, no network
 * with KioskOfflineException.
 */
interface KioskChecklistRepository {
    /** The checklists of [shiftId] not finished, for [moment]; empty when there are none. */
    suspend fun list(userId: String, pin: String, shiftId: String, moment: KioskChecklistMoment): Result<List<ShiftChecklist>>

    /** Ticks (or unticks) [itemId] with [note]; returns the checklist as stored. */
    suspend fun tick(
        userId: String,
        pin: String,
        shiftId: String,
        templateId: String,
        itemId: String,
        done: Boolean,
        note: String?
    ): Result<ShiftChecklist>

    /** Records that the person went on without finishing [templateIds] (the reminder still goes out). */
    suspend fun skip(userId: String, pin: String, shiftId: String, templateIds: List<String>): Result<Unit>
}
